import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { TOGGLE_LAYOUT } from "../../../store/layout/Actions";

import useStyles from "./styles";
import clsx from "clsx";

export function AgentCommissionView() {
  const styles = useStyles();
  const dispatch = useDispatch();
  useEffect(() => {
    const tId = setTimeout(() => {
      dispatch(TOGGLE_LAYOUT());
    }, 1300);

    return () => {
      clearTimeout(tId);
    };
  }, []);
  return (
    <div class={clsx(styles.card)}>
      <div class={styles.content}>
        <div class={styles.shared}>Old Layout</div>
        <div class={clsx(styles.shared, styles.back)}>New Layout</div>
      </div>
    </div>
  );
}
